import {
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
  } from '@mui/material'
  import { Link } from 'react-router-dom'
  import '../css/style.css'
  
  type Props = {
    Icon: JSX.Element
    ListName: string
    Url: string
  }
  
  function MenuList(props: Props) {
    return (
      <>
        <Link to={props.Url}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>{props.Icon}</ListItemIcon>
              <ListItemText sx={{ color: '#2f4858' }}primary={props.ListName}/>
            </ListItemButton>
          </ListItem>
        </Link>
      </>
    )
  }
  
  export default MenuList